import React from 'react'
import Slider from 'react-slick';
import Partner_1 from '../../../assets/images/patner/patner-four-1.png';
import Partner_2 from '../../../assets/images/patner/patner-four-2.png';
import Partner_3 from '../../../assets/images/patner/patner-four-3.png';
import Partner_4 from '../../../assets/images/patner/patner-four-4.png';
import Partner_5 from '../../../assets/images/patner/patner-four-5.png';



const Partner = () => {
    const Part = {
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
    }
    return (
        <>
            <div className="patner-section-four">
                <div className="container-fluid p-0">
                    <Slider className="patner-slider-four" {...Part}>
                        <div className="patner-slide-item-four">
                            <img src={Partner_1} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_2} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_3} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_4} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_5} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_1} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-four">
                            <img src={Partner_2} alt="patner-logo" />
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Partner
